import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { filter } from 'rxjs/operators';

import { IParceiro, IParceiroContato } from '@app/modules/parceiro/model';

import { animate, style, transition, trigger } from '@angular/animations';
import { TokenService } from 'viggo-sistemas-core-web';
import { DialogDelContatoComponent } from '../dialog-del-contato/dialog-del-contato.component';
import { DialogEditContatoComponent } from '../dialog-edit-contato/dialog-edit-contato.component';

@Component({
  selector: 'app-fast-contato',
  templateUrl: './fast-contato.component.html',
  styleUrls: ['./fast-contato.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0, height: 0 }),
        animate('0.2s', style({ opacity: 1, height: '*' }))
      ]),
      transition(':leave', [
        style({ height: '*' }),
        animate('0.2s', style({ opacity: 0, height: 0 }))
      ])
    ])
  ]
})
export class FastContatoComponent implements OnInit, OnChanges {
  @Input() entity: IParceiro;

  @Input() readonly = false;

  @Output() tags = new EventEmitter<[]>();

  blocked_actions = false;

  entityTemp: IParceiro;

  constructor(public dialog: MatDialog, public tokenService: TokenService) {}

  ngOnChanges() {
    if (this.tokenService.isLoggedIn()) {
      this.entityTemp = this.entity;

      if (!this.entityTemp.contatos) this.entityTemp.contatos = [];
      else
        this.entityTemp.contatos.forEach(contato => {
          if (typeof contato.tag === 'string')
            contato.tag = contato.tag.split(' ');
        });
      // this.tags.emit()
    }
  }

  ngOnInit(): void {
    this.entityTemp = this.entity;

    if (!this.entityTemp.contatos) this.entityTemp.contatos = [];
    else
      this.entityTemp.contatos.forEach(contato => {
        if (typeof contato.tag === 'string')
          contato.tag = contato.tag.split(' ');
      });

    this.blocked_actions =
      localStorage.getItem('INTEGRACAO') === 'true' ? true : false;
  }

  public addContato(): void {
    const observer = this.dialog
      .open(DialogEditContatoComponent, {
        data: {
          contato: {
            contato: '',
            tag: ''
          }
        },
        panelClass: [
          'custom-container',
          'position-relative',
          'dialog-sem-padding'
        ],
        position: {
          top: '0px'
        }
      })
      .afterClosed();
    observer
      .pipe(filter(result => !!result))
      .subscribe((result: IParceiroContato) => {
        // delete result.tags
        if (result) this.entityTemp.contatos.push(result);
      });
  }

  public editarContato(contato: IParceiroContato, index: number): void {
    if (!contato && index < 0) return;

    const observer = this.dialog
      .open(DialogEditContatoComponent, {
        width: '400px',
        data: {
          contato
        },
        panelClass: ['dialog-sem-padding'],
        position: {
          top: '75px'
        }
      })
      .afterClosed();

    observer
      .pipe(filter(resposta => !!resposta))
      .subscribe((respostaContato?: IParceiroContato) => {
        // delete respostaContato.tags
        this.entityTemp.contatos[index] = respostaContato;
      });
  }

  formatarTags(tag: string[]): string[] {
    if (typeof tag === 'object') return tag.filter(tg => tg !== '');
    else return tag;
  }

  removerContato(event: MouseEvent, contato: IParceiroContato): void {
    event.stopPropagation();
    const index = this.entityTemp.contatos.findIndex(
      contatoExistente =>
        contatoExistente.id === contato.id &&
        contatoExistente.contato === contato.contato
    );

    if (index >= 0) {
      const observer = this.dialog
        .open(DialogDelContatoComponent, {
          data: {
            nomeEntidade: 'Contato',
            descricaoEntidade: this.entityTemp.contatos[index].contato
          },
          position: {
            top: '75px'
          }
        })
        .afterClosed();
      observer.pipe(filter(resposta => resposta)).subscribe((): void => {
        this.entityTemp.contatos.splice(index, 1);
      });
    }
  }

  public updateValues(parceiro: IParceiro): void {
    if (!parceiro.contatos) {
      this.entityTemp.contatos = [];
      return;
    }
    this.entityTemp = parceiro;
  }

  getValues(): IParceiroContato[] {
    if (!this.entityTemp.contatos.length) return [];
    return this.entityTemp.contatos.map(
      (contato): IParceiroContato => ({
        ...contato,
        tag:
          typeof contato.tag === 'string' ? contato.tag : contato.tag.join(' ')
      })
    );
  }
}
